// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appFormCheckBox .ui.checkbox{min-height:13px !important}`, "",{"version":3,"sources":["webpack://./src/client/ui-building-blocks/AppFormCheckBox/app-form-check-box.scss"],"names":[],"mappings":"AACE,8BACE,0BAAA","sourcesContent":[".appFormCheckBox {\n  .ui.checkbox {\n    min-height: 13px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
